module.exports = __webpack_public_path__ + "5fdf91fd49b45356e8bf60434ce75d7c.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=1400!./images/head/ALLEYESONUS_HEAD2.jpg
// module id = 755
// module chunks = 0